/* CF山梨: ギャラリーのライトボックス(Step6)
   - sections/cf-gallery.liquid の <cf-gallery> 配下で完結(グローバル汚染なし)
   - アルバムデータは同セクション内の <script type="application/json"> から読む
   - ネイティブ <dialog> を使用。メイン写真は画面に収まるサイズ、下のサムネ一覧から好きな写真を選べる
   - 矢印キー・スワイプ・余白クリックでも操作できる。写真ごとの説明(caption)があれば写真の下に表示
   - 動きは控えめなフェードのみ(prefers-reduced-motion はCSS側で無効化) */
(() => {
  if (customElements.get('cf-gallery')) return;

  class CFGallery extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('script[data-cf-gallery-data]');
      this.albums = {};
      if (dataEl) {
        try {
          this.albums = JSON.parse(dataEl.textContent);
        } catch (e) {
          this.albums = {};
        }
      }
      this.dialog = this.querySelector('dialog[data-cf-lightbox]');
      if (!this.dialog) return;
      this.imgEl = this.dialog.querySelector('[data-cf-lb-img]');
      this.titleEl = this.dialog.querySelector('[data-cf-lb-title]');
      this.counterEl = this.dialog.querySelector('[data-cf-lb-counter]');
      this.captionEl = this.dialog.querySelector('[data-cf-lb-caption]');
      this.thumbsEl = this.dialog.querySelector('[data-cf-lb-thumbs]');
      this.album = null;
      this.index = 0;
      this.thumbButtons = [];

      this.querySelectorAll('[data-cf-album]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(btn.dataset.cfAlbum));
      });
      this.dialog.querySelector('[data-cf-lb-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('[data-cf-lb-prev]').addEventListener('click', () => this.move(-1));
      this.dialog.querySelector('[data-cf-lb-next]').addEventListener('click', () => this.move(1));

      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.move(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.move(1);
        }
      });
      // メイン写真の外側(余白)クリックで閉じる。サムネ・操作ボタンの押下では閉じない
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog || e.target.classList.contains('cf-gallery-lightbox__stage')) {
          this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cf-gallery-open');
        this.imgEl.classList.remove('is-loaded');
        this.imgEl.removeAttribute('src');
      });
      this.imgEl.addEventListener('load', () => this.imgEl.classList.add('is-loaded'));

      // スワイプ(メイン写真の上のみ。サムネの横スクロールは妨げない)
      let touchX = null;
      const stage = this.dialog.querySelector('.cf-gallery-lightbox__stage');
      stage.addEventListener('touchstart', (e) => { touchX = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 48) this.move(dx > 0 ? -1 : 1);
        touchX = null;
      }, { passive: true });
    }

    open(handle) {
      const album = this.albums[handle];
      if (!album || !album.photos.length) return;
      this.album = album;
      this.titleEl.textContent = album.title;
      this.buildThumbs(album);
      document.documentElement.classList.add('cf-gallery-open');
      this.show(0);
      this.dialog.showModal();
    }

    buildThumbs(album) {
      this.thumbsEl.textContent = '';
      this.thumbButtons = album.photos.map((p, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cf-gallery-lightbox__thumb';
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('aria-label', `${i + 1}枚目`);
        const img = document.createElement('img');
        img.loading = 'lazy';
        img.width = 64;
        img.height = 64;
        img.src = p.thumb || p.src;
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', () => this.show(i));
        this.thumbsEl.appendChild(btn);
        return btn;
      });
    }

    move(step) {
      if (!this.album) return;
      const n = this.album.photos.length;
      this.show((this.index + step + n) % n);
    }

    show(i) {
      this.index = i;
      const photos = this.album.photos;
      const p = photos[i];
      this.imgEl.classList.remove('is-loaded');
      if (p.w) this.imgEl.width = p.w;
      if (p.h) this.imgEl.height = p.h;
      this.imgEl.alt = `${this.album.title} ${i + 1}枚目`;
      this.imgEl.src = p.src;
      if (this.imgEl.complete && this.imgEl.naturalWidth > 0) this.imgEl.classList.add('is-loaded');

      this.counterEl.textContent = `${i + 1}/${photos.length}`;

      const caption = (p.caption || '').trim();
      this.captionEl.textContent = caption;
      this.captionEl.hidden = caption === '';

      this.thumbButtons.forEach((btn, j) => {
        const active = j === i;
        btn.classList.toggle('is-active', active);
        if (active) {
          btn.setAttribute('aria-current', 'true');
          btn.scrollIntoView({ inline: 'center', block: 'nearest' });
        } else {
          btn.removeAttribute('aria-current');
        }
      });

      // 前後1枚を先読みして待ち時間を減らす
      [i - 1, i + 1].forEach((j) => {
        const q = photos[(j + photos.length) % photos.length];
        if (q) new Image().src = q.src;
      });
    }
  }

  customElements.define('cf-gallery', CFGallery);
})();
